import { takeEvery, put, call } from "redux-saga/effects"

// Product Redux States
import {
    GET_PRODUCTS,
    GET_PRODUCT_DETAIL,
    ADD_NEW_PRODUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
} from "./actionTypes"

import {
    getProductsSuccess,
    getProductsFail,
    getProductDetailSuccess,
    getProductDetailFail,
    addNewProductSuccess,
    addNewProductFail,
    updateProductSuccess,
    updateProductFail,
    deleteProductSuccess,
    deleteProductFail,
} from "./actions"

// Include helper Step 1
import {
    getProducts,
    getProductDetail,
    addNewProduct,
    updateProduct,
    deleteProduct,
} from "../../helpers/fakebackend_helper"

function* fetchProducts({ payload: params }) {
    try {
        const response = yield call(getProducts, params)
        yield put(getProductsSuccess(response))
    } catch (error) {
        yield put(getProductsFail(error))
    }
}

function* fetchProductDetail({ payload: id }) {
    try {
        const response = yield call(getProductDetail, id)
        yield put(getProductDetailSuccess(response))
    } catch (error) {
        yield put(getProductDetailFail(error))
    }
}

function* onAddNewProduct({ payload: product }) {
    try {
        const response = yield call(addNewProduct, product)
        yield put(addNewProductSuccess(response))
    } catch (error) {
        yield put(addNewProductFail(error))
    }
}

function* onUpdateProduct({ payload: product }) {
    try {
        const response = yield call(updateProduct, product)
        yield put(updateProductSuccess(response))
    } catch (error) {
        yield put(updateProductFail(error))
    }
}

function* onDeleteProduct({ payload: id }) {
    try {
        const response = yield call(deleteProduct, id)
        yield put(deleteProductSuccess(response))
    } catch (error) {
        yield put(deleteProductFail(error))
    }
}

function* productSaga() {
    yield takeEvery(GET_PRODUCTS, fetchProducts)
    yield takeEvery(GET_PRODUCT_DETAIL, fetchProductDetail)
    yield takeEvery(ADD_NEW_PRODUCT, onAddNewProduct)
    yield takeEvery(UPDATE_PRODUCT, onUpdateProduct)
    yield takeEvery(DELETE_PRODUCT, onDeleteProduct)
}

export default productSaga
